export enum AuthRole {
  DEPLOYMENT_INITIATE = 'DEPLOYMENT_INITIATE',
  PUBLISH = 'PUBLISH',
  ADMIN = 'ADMIN',
  ALL = 'ALL'
}
